module.exports = __webpack_public_path__ + "img/bb.426f3624.svg";